export default __webpack_public_path__ + "static/media/Earrings-Category-List.787a1f51.jpg";